import TreeSelectorComponent from '@/components/commons/tree-selector/TreeSelectorComponent.vue'
import { EventHub } from '@/constants/constants'
import { profileService } from '@/services/profile.service'
import { DialogUserProfile } from '@/tools/dialog'
import { mapActions } from 'vuex'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'UserDialogEnterpriseTabComponent',
    components: {
        DialogUserProfile,
        TreeSelectorComponent,
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // loading del selector de empresas
        loadingEnterprises: false,
        // selector de empresas
        enterprises: [],
        // loading del selector de perfiles
        loadingProfiles: false,
        // selector de perfiles
        profiles: []
    }),
    computed: {
    },
    created() {
        // Evento lanzado por el diálogo de creación de perfil, cuando se guarda el nuevo perfil
        this.$eventBus.$on(EventHub.COMMIT_USER_PROFILE, (profileDto) => {
            this.getUserProfiles(profileDto._id)
        })
    },
    mounted() {
        this.getUserProfiles()
    },
    methods: {
        /**
         * actions del breadcrumb
         */
        ...mapActions('breadcrumbs', [
            'pushBread'
        ]),
        selectorMapper(node) {
            return {
                id: node._id,
                label: node.name
            }
        },
        updateSelected(enterprises) {
            this.model.enterprises = enterprises;
            // si se limpia la selección, también elimino el perfil seleccionado
            if (enterprises.length === 0) {
                this.model.profileId = null
            } else {
                this.getUserProfiles()
            }
        },
        /**
         * Arreglo de perfiles para asignar
         * @param {*} profileId si se crea un perfil nuevo, se setea como seleccionado
         */
        getUserProfiles(profileId) {
            this.loadingProfiles = true
            if (this.model.enterprises) {
                profileService.getAllForSelectorUserABM(this.model.enterprises).then(response => {
                    this.profiles.cleanAndUpdate(response)
                    if (profileId) {
                        const profileData = this.profiles.find(profile => profile._id === profileId)
                        this.model.profileId = profileData ? profileData._id : null;
                    }
                    this.loadingProfiles = false
                })
            } else {
                this.model.profileId = null
            }
        },
        /**
         * Carga el dialog para crear perfiles
         */
        openProfile() {
            const bread = {
                key: DialogUserProfile,
                disabled: true,
                text: this.$t('userProfiles.name')
            }
            this.pushBread(bread)
        },
        /**
         * Cada vez que se modifica la selección del perfil, se cargan
         */
        profileSelectedFunction (newValue) {
            this.model.profileId = newValue._id ? newValue._id : newValue;
        },
    },
    watch: {
        'model.enterprises': {
            deep: true,
            immediate: true,
            handler: function (newEnterprises) {
                this.$emit('enterpriseSelected', newEnterprises)
            }
        },
        /**
         * Actualizo el valor de la prop
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.userDialogEnterpriseTabForm) {
                this.$refs.userDialogEnterpriseTabForm.resetValidation()
            }
        }
    }
}
